import { apiClient } from './client';

/**
 * API клиент для модуля пользовательского соглашения (оферты).
 * Спецификация: SUP-107.
 */
export const termsApi = {
  /**
   * Получить текущую активную версию оферты.
   * Публичный эндпоинт — не требует auth.
   * GET /terms/current
   */
  async getCurrent(): Promise<TermsVersion> {
    const response = await apiClient.get<TermsVersion>('/terms/current');
    return response.data;
  },

  /**
   * Зафиксировать акцепт версии оферты.
   * Требует auth. Если version не указан — акцепт текущей активной версии.
   * Идемпотентно: повторный акцепт той же версии не возвращает ошибку.
   * POST /terms/accept
   */
  async accept(version?: string): Promise<TermsAcceptance> {
    const response = await apiClient.post<TermsAcceptance>('/terms/accept', { version });
    return response.data;
  },

  /**
   * Проверить, нужно ли пользователю принять актуальную версию.
   * Используется для баннера «обновлены условия».
   * GET /terms/needs-acceptance
   */
  async needsAcceptance(): Promise<NeedsAcceptanceResponse> {
    const response = await apiClient.get<NeedsAcceptanceResponse>('/terms/needs-acceptance');
    return response.data;
  },

  /**
   * Получить историю акцептов пользователя.
   * GET /terms/acceptances
   */
  async listAcceptances(): Promise<TermsAcceptance[]> {
    const response = await apiClient.get<{ acceptances: TermsAcceptance[] }>('/terms/acceptances');
    // Защита от null (Go nil slice → JSON null, INC-20260713-002).
    return response.data?.acceptances ?? [];
  },
};

export interface TermsVersion {
  version: string;
  published_at: string;
  summary: string;
}

export interface TermsAcceptance {
  version: string;
  accepted_at: string;
}

export interface NeedsAcceptanceResponse {
  needs_acceptance: boolean;
  current_version?: string;
}
